@if (authService.isAuthenticationInProgress$ | async) {
  <div class="d-flex justify-content-center align-items-center h-100 min-height-vh-100">
    <div class="spinner-border spinner-border-sm" role="status" id="authLoginProgressSpinner">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
}
@if ((isDocsRoute$ | async) === false && ((hideNavigation$ | async) === false || (authService.isAuthenticationInProgress$ | async))) {
  <div id="app-header">
    <app-header [hideUserSettings]="hideNavigation$"></app-header>
  </div>
}
@if ((authService.isClientNavigationInProgress$ | async) === false) {
  <div id="app-content" [ngClass]="{ 'h-100 mt-0': (hideNavigation$ | async) }">
    <div class="container-fluid mh-section-content" [ngClass]="{ 'h-100 w-100 px-0': (hideNavigation$ | async) }">
      <div class="row g-0" [ngClass]="{ 'h-100 w-100': (hideNavigation$ | async) }">
        <div class="col" [ngClass]="{ 'h-100': (hideNavigation$ | async) }">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
}
<app-back-to-top></app-back-to-top>
@if ((hideNavigation$ | async) === false) {
  <app-ignite-assistant *ngxPermissionsOnly="'ignite-assistant-viewer'"></app-ignite-assistant>
}
@if ((hideNavigation$ | async) === false) {
  <div id="app-footer" class="mt-auto">
    <app-footer></app-footer>
  </div>
}
